export const pathConfig = {
    api: process.env.REACT_APP_API,
    api_nest: process.env.REACT_APP_API_NEST,
    app: process.env.REACT_APP_PATH
};